import { Component } from '@angular/core';
import { Platform } from '@ionic/angular';
import { environment } from '../environments/environment';
import { IAppClientDetail, IVersion, SharedConfig } from '@takectrl-multiapp/svcs-share-config';
import { APIHttpService } from 'libs/svcs-ctrl-api/src/lib/services/api-http.service';

import { HttpClient } from '@angular/common/http';
import { register } from 'swiper/element/bundle';
register();
@Component({
  selector: 'takectrl-multiapp-root',
  standalone: false,
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  constructor(
    private http: HttpClient,
    private readonly platform: Platform,
    public apiHttpService: APIHttpService,
    public sharedConfig: SharedConfig // private themeSwitcher : ThemeSwitcherService
    
  ) {
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      // below theme switcher for mnultitenancy.
      // this.themeSwitcher.setTheme(environment.client.client_name_key)
      SharedConfig.appCredentials = {
        firebase_credentials: environment.firebase,
        ctrl_api_url: environment.ctrl_api_url,
        firebase_functions_url: environment.firebase_functions_url,
        application: environment.application,
      };
      if ('intercom_app_id' in environment) {
        SharedConfig.appCredentials.intercom_app_id = environment.intercom_app_id as string
      }
      SharedConfig.production = environment.production;
      SharedConfig.production = environment.production;
      this.sharedConfig.setAppClientDetail(environment.app_client_detail as unknown as IAppClientDetail);
      this.http.get('/assets/version.json').subscribe(data => {
        this.sharedConfig.setAppVersion((data as IVersion).version);
      });
      this.apiHttpService.setBaseUrl(environment.ctrl_api_url);

      //this.statusBar.styleDefault();
      //this.splashScreen.hide();
    });
  }
}
